// src/utils/finance/format.js
import dayjs from "dayjs";

export function toYmd(date) {
  return dayjs(date).format("YYYY-MM-DD");
}

export function formatPen(valueStrOrNumber) {
  const n = Number(valueStrOrNumber || 0);
  return n.toLocaleString("es-PE", { style: "currency", currency: "PEN" });
}
